import React, {Component} from "react";
import {OptionalTableCell} from "../../../shared/component/OptionalTableCell";

export class LoanDetailsTableLoanAmount extends Component<{ loanAmount: string }> {
    render() {
        return <OptionalTableCell title='Loan Amount'>
            {this.props.loanAmount}
        </OptionalTableCell>
    }
}